// extracted by mini-css-extract-plugin
export default {"container":"NextEntityPlacementSelector_container__C1Ta8","loadingOverlay":"NextEntityPlacementSelector_loadingOverlay__Vtylg"};